if (!customElements.get('product-footbar')) {
  scriptController.executeWhenScriptLoaded('product-form.js', () => {
    class ProductFootbar extends HTMLElement {
      constructor() {
        super();
        this.product = document.querySelector('.product');        
        this.productButtonAddToCart = this.product.querySelector('[name="add"]');
        this.variants = this.querySelector('[name="id"]');

        this.variants.addEventListener('change', this.onChange.bind(this));        
        window.addEventListener('MutationObserverLoaded', this.onResize.bind(this));
        window.addEventListener('resize', this.onResize.bind(this));
        window.addEventListener('scroll', this.onScroll.bind(this));
      }

      onChange(event) {
        const options = event.target.querySelectorAll('option');
        const productVariantSwitcher = document.querySelector(`variant-radios[data-section="${this.dataset.sectionId}"]`) || document.querySelector(`variant-selects[data-section="${this.dataset.sectionId}"]`);

        options.forEach(element => {
          if (element.selected) {
            const variantData = JSON.parse(this.product.querySelector('[type="application/json"]').textContent);
            const currentVariant = variantData.filter((variant) => {
              return variant.id == element.value;
            })[0];

            productVariantSwitcher.changeOptions(currentVariant.options);
            productVariantSwitcher.onVariantChange({ isFootbar: true });
            return false;
          }
        });
      }

      onResize() {
        this.checkOverlay();
      }

      onScroll() {
        this.checkOverlay();
      }

      checkOverlay() {
        const productButtonAddToCartBound = this.productButtonAddToCart.getBoundingClientRect();

        this.classList[productButtonAddToCartBound.bottom < 0 ? 'add' : 'remove']('product-footbar__wrapper--visible');
      }
    }

    customElements.define('product-footbar', ProductFootbar);
  });
}
window.addEventListener('scroll', () => {
  const productForm = document.querySelector('.product-form');
  const footerBar = document.querySelector('#product-footbar-main .product-footbar__wrapper');

   // Get bottom position of the form
  const formBottom = productForm.offsetTop + productForm.offsetHeight;

  // How far user has scrolled
  const scrollPosition = window.scrollY + window.innerHeight;

  if (scrollPosition > formBottom) {
    footerBar.classList.add('product-footbar__wrapper--visible');
  } else {
    footerBar.classList.remove('product-footbar__wrapper--visible');
  }
});
